import { QuickSets } from '../../models/QuickSets';

export class AddQuickSet {
  static readonly type = '[quickSet] add';
  constructor(public payload: QuickSets) {}
}

export class RemoveQuickSet {
  static readonly type = '[quickSet] remove';
  constructor() {
    /**/
  }
}
